require('owl.carousel')


// WEBPACK FOOTER //
// ./resources/assets/js/vendor/owl-carousel.js